/**
 * Generate cropped image URLs for Shopify images
 * @param {string} url - The original image URL
 * @param {number|number[]} sizes - Single size or array of sizes for responsive images
 * @param {string} aspectRatio - Aspect ratio as a string (e.g., "1/1", "4/5", "5/7")
 * @returns {string|string[]} - Cropped image URL(s)
 */
export const getCroppedImageUrl = (url, sizes, aspectRatio = '4/5') => {
  if (!url) return ['/placeholder.jpg']

  const parts = url.split('?')
  const base = parts[0]
  const query = parts[1] ? '?' + parts[1] : ''

  const lastDot = base.lastIndexOf('.')
  if (lastDot === -1) return [url]

  // Calculate height multiplier from aspect ratio
  const getHeightMultiplier = (ratio) => {
    const ratioMap = {
      '1/1': 1,      // 1/1 = 1
      '4/5': 1.25,   // 5/4 = 1.25
      '5/7': 1.4     // 7/5 = 1.4
    }
    return ratioMap[ratio] || 1.25 // Default to 4/5 if unknown ratio
  }

  const heightMultiplier = getHeightMultiplier(aspectRatio)

  // If sizes is an array, return array of cropped URLs
  if (Array.isArray(sizes)) {
    return sizes.map(size => {
      const width = Math.round(size);
      const height = Math.round(size * heightMultiplier);
      const cropped = base.slice(0, lastDot) + `_${width}x${height}_crop_center` + base.slice(lastDot);
      return cropped + query + ` ${size}w`
    })
  }

  // Fallback for single size (backward compatibility)
  const cropped = base.slice(0, lastDot) + '_240x240_crop_center' + base.slice(lastDot)
  return cropped + query
}

export default getCroppedImageUrl;
